"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const less = require("less");
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const errors = __importStar(require("../errors"));
class LessProcessor {
    constructor() {
        this.options = {};
    }
    async execute(ctx) {
        let ext = path.extname(ctx.virtualPath);
        if (ext != ".css" && ext != ".less")
            return null;
        let virtualPath = ext == ".css" ?
            ctx.virtualPath.substr(0, ctx.virtualPath.length - ".css".length) + ".less"
            : ctx.virtualPath;
        let dir = this.options.directoryPath ? ctx.rootDirectory.findDirectory(this.options.directoryPath) : ctx.rootDirectory;
        if (dir == null)
            throw errors.pageNotFound(virtualPath);
        let physicalPath = dir.findFile(virtualPath);
        if (physicalPath == null || !fs.existsSync(physicalPath))
            throw errors.pageNotFound(virtualPath);
        let buffer = fs.readFileSync(physicalPath);
        let originalCode = buffer.toString();
        let output = await less.render(originalCode, {
            paths: [physicalPath]
        });
        return {
            content: output.css,
            headers: { "Content-Type": "text/css; charset=UTF-8" }
        };
    }
}
exports.LessProcessor = LessProcessor;
